export default {
  notifications: 'Notifications',
  'notifications.allNotifications': 'All Notifications',
  'notifications.read': 'Read',
  'notifications.unread': 'Unread',
};
